<template>
    <Link :href="'/song/' + song.id"
        class="group flex w-full items-center gap-4 rounded-2xl p-2 pr-4 transition-colors duration-200 hover:bg-white/[0.05] focus:outline-none focus-visible:ring-2 focus-visible:ring-nomad-accent">
        <!-- Artwork with play overlay -->
        <div class="relative h-14 w-14 shrink-0 overflow-hidden rounded-xl bg-nomad-800 ring-1 ring-white/[0.08] sm:h-16 sm:w-16">
            <img v-if="artwork" :src="artwork" :alt="`${title} cover`" loading="lazy"
                class="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            <span v-else class="icon-music absolute inset-0 flex items-center justify-center text-xl text-nomad-500"></span>
            <button type="button" @click.prevent.stop="play" :aria-label="'Play ' + title"
                class="absolute inset-0 flex items-center justify-center bg-black/55 opacity-0 transition-opacity duration-200 focus:opacity-100 group-hover:opacity-100">
                <span class="nl-play-fab h-9 w-9 text-sm"><span class="icon-play translate-x-px"></span></span>
            </button>
        </div>

        <!-- Song info -->
        <div class="min-w-0 flex-1">
            <h2 class="line-clamp-1 text-[0.9375rem] font-semibold text-white transition-colors group-hover:text-nomad-accent">
                {{ title }}
            </h2>
            <h3 v-if="song.artist" class="mt-0.5 line-clamp-1 text-sm text-nomad-300">
                {{ song.artist.name }}
            </h3>
        </div>

        <!-- Duration -->
        <span v-if="song.formatted_duration" class="shrink-0 text-xs tabular-nums text-nomad-400">
            {{ song.formatted_duration }}
        </span>
        <span class="icon-chevron-right shrink-0 text-nomad-500 opacity-0 transition-all group-hover:translate-x-0.5 group-hover:opacity-100"
            aria-hidden="true"></span>
    </Link>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { Link } from "@inertiajs/vue3";
export default {
    name: "CardSong",
    props: {
        song: Object,
    },
    components: {
        Link,
    },
    computed: {
        title() {
            return this.song.title || this.song.name;
        },
        artwork() {
            return this.song.artwork || this.song.meta?.image || this.song.cover || this.song.artist?.image;
        },
    },
    methods: {
        ...mapActions("favorites", [""]),
        ...mapActions("current", ["prepareCurrent"]),
        play() {
            this.prepareCurrent({ id: this.song.id, type: 'SONG', name: this.title });
        },
    },
};
</script>
